import { useRef, useState } from "react";

import Dropzone from "react-dropzone";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { getEnv } from "helpers/environment";

const baseStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: "50%",
  width: "150px",
  height: "150px",
  borderColor: "#e1e1e1ff",
  borderStyle: "dashed",
  //backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out"
};

const focusedStyle = {
  borderColor: "#2196f3"
};

const acceptStyle = {
  borderColor: "#00e676"
};

const rejectStyle = {
  borderColor: "#ff1744"
};

function FileDropzone({ setFile }) {
  const dropzoneRef = useRef();
  const openDialog = () => {
    dropzoneRef?.current?.open();
  };
  const [onDrag, setOnDrag] = useState(false);
  const maxSize = getEnv("MAX_FILE_INPUT_SIZE");

  return (
    <Dropzone
      ref={dropzoneRef}
      onDrop={(acceptedFiles) => setFile(acceptedFiles[0])}
      onDragEnter={() => setOnDrag(true)}
      onDragLeave={() => setOnDrag(false)}
      maxFiles={1}
      accept={{ "image/jpeg": [], "image/png": [] }}
      noClick
      noKeyboard
      maxSize={maxSize}
    >
      {({ getRootProps, getInputProps, isFocused, isDragAccept, isDragReject, fileRejections }) => {
        const isFileTooLarge = fileRejections
          ? fileRejections.length > 0 && fileRejections[0].file.size > maxSize
          : null;

        return (
          <SoftBox
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 2
            }}
          >
            <SoftBox
              {...getRootProps()}
              style={{
                ...baseStyle,
                ...(isFocused ? focusedStyle : {}),
                ...(isDragAccept ? acceptStyle : {}),
                ...(isDragReject ? rejectStyle : {})
              }}
            >
              <input {...getInputProps()} />
              {onDrag ? (
                isDragReject ? (
                  <SoftTypography
                    variant="button"
                    color="secondary"
                    fontSize="12px"
                    fontWeight="light"
                  >
                    Invalid File Type: Please choose an image
                  </SoftTypography>
                ) : (
                  <SoftTypography
                    variant="button"
                    color="secondary"
                    fontSize="12px"
                    fontWeight="light"
                  >
                    Drop here
                  </SoftTypography>
                )
              ) : (
                <SoftTypography
                  variant="button"
                  color="secondary"
                  fontSize="12px"
                  fontWeight="light"
                >
                  Drag and drop your image here
                </SoftTypography>
              )}
            </SoftBox>
            {isFileTooLarge && (
              <SoftTypography sx={{ color: "#ff3e3e", fontSize: "14px" }}>
                File is too large.
              </SoftTypography>
            )}
            <SoftTypography variant="button" fontWeight="regular">
              or
            </SoftTypography>
            <SoftButton color="secondary" size="small" onClick={openDialog}>
              Choose File
            </SoftButton>
          </SoftBox>
        );
      }}
    </Dropzone>
  );
}

export default FileDropzone;
